var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_vm._v("上海原圈网络科技有限公司 "),_c('span',[_vm._v(_vm._s(this.info ? this.info.nickname : ""))])])}
var staticRenderFns = []

export { render, staticRenderFns }